module.exports = __webpack_public_path__ + "static/note-taker-bb2017ebbdaada7fcf333ea0d5579b8b.jpg";